import React, { useCallback, useEffect, useState } from 'react';

import Skeleton from 'react-loading-skeleton';
import Autocomplete from 'react-autocomplete';

import { MdAddShoppingCart } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { layout } from '../../../package.json';

import {
  Root,
  Container,
  ContainerLogo,
  ContainerInputBox,
  ContainerInputResultItem,
  ContainerInputResultItemImage,
  ContainerInputResultItemTitle,
  ContainerInputResultItemCategory,
  ContainerInputResultItemPrice,
  ContainerInputResultItemActions,
} from './styles';

// import { FiUser, FiHeart, FiShoppingCart, FiSearch } from 'react-icons/fi';
import {config} from '../../config';

import { StoreState } from '../../store/createStore';
import {
  detailsProduct,
  findProductSearch,
  findProductSuccess,
  findProductRequest,
  setProductFilter,
} from '../../store/modules/product/actions';
import { resetCategoriesSelected } from '../../store/modules/category/actions';
import { checkoutActionTypes } from '../../store/modules/checkout/types';
import {
  ProductActionTypes,
  productData,
  ProductData,
} from '../../store/modules/product/types';
import { routesEndpoints } from '../../routes/endpoint';
import { useTranslation } from '../../hooks/useTranslation';
import { useCheckoutFunction } from '../../hooks/useCheckoutFunctions';
import { NavLink } from '../../components/NavLink';
import { RoundHelper } from '../../utils/roundHelper';

const Search: React.FC = () => {
  const history = useHistory();
  const [searchData, setSearchData] = useState('');
  const { search, loadingSearch } = useSelector(
    (state: StoreState) => state.product,
  );
  const { loading } = useSelector((state: StoreState) => state.checkout);

  const dispatch = useDispatch();
  const { onTranslation: t } = useTranslation();
  const { handleCheckoutActions } = useCheckoutFunction();

  const handleSearch = useCallback(async value => {
    setSearchData(value);
  }, []);

  useEffect(() => {
    if (searchData === '') return;

    const timeoutId = setTimeout(() => {
      dispatch(findProductSearch({
        term: searchData
      }));
    }, 500);

    return () => window.clearTimeout(timeoutId);
  }, [searchData, dispatch]);

  const handleDetailsProduct = useCallback(
    async (data: productData, product: productData) => {
      //konsole.log('handleDetailsProduct: ', product);
      switch (data.type) {
        case ProductActionTypes.DETAILS:
          if (product.products) {
            dispatch(findProductSuccess(product.products));
            dispatch(detailsProduct(product.products));
          }
          history.push(`/produto?id=${product.products?.id}`);
          setSearchData('');
          break;

        default:
      }
    },
    [dispatch, history],
  );

  return (
    <Root>
      <Container>
        <ContainerLogo
          onClick={() => {
            if (!loading) {
              dispatch(resetCategoriesSelected());
              dispatch(
                setProductFilter({
                  categoryId: '',
                }),
              );
              dispatch(findProductRequest());
              history.push({
                pathname: routesEndpoints.HOME,
                search: '',
              });
            }
          }}
        >
          <img src={config.logo} alt="ConectoGO" width={100} />
        </ContainerLogo>

        <ContainerInputBox className="containerinputbox">
          <Autocomplete
            value={searchData}
            inputProps={{ placeholder: t('main.search.input') }}
            items={search}
            getItemValue={item => item.short_description}
            onChange={(event, value) => {
              handleSearch(value);
            }}
            onSelect={(text, product) => {

              handleDetailsProduct(
                { type: ProductActionTypes.DETAILS },
                { products: product && product },
              );
            }}
            menuStyle={{
              borderRadius: '3px',
              boxShadow: '0 2px 12px rgba(0, 0, 0, 0.8)',
              background: 'rgba(255, 255, 255, 1)',
              padding: '2px 0',
              fontSize: '90%',
              position: 'absolute',
              overflow: 'auto',
              maxHeight: '50%',
              maxWidth: layout.mobile ? '300px' : '800px',
              justifyContent: 'center',
            }}
            renderInput={params => (
              <input
                {...params}
                placeholder={t('main.search.input')}
                onKeyDown={e => {
                  if (e.keyCode === 13) {
                    return false;
                  }
                }}
              />
            )}
            renderItem={(product: ProductData) => {
              if (loadingSearch) {
                return (
                  <ContainerInputResultItem>
                    <Skeleton
                      duration={1}
                      width={730}
                      height={52}
                      style={{ marginLeft: '0px' }}
                    />
                  </ContainerInputResultItem>
                );
              }

              return (
                <ContainerInputResultItem key={product.id}>
                  <ContainerInputResultItemImage>
                    <img
                      src={product?.image_url}
                      alt={product?.short_description}
                    />
                  </ContainerInputResultItemImage>

                  <ContainerInputResultItemTitle>
                    <span>{product?.short_description}</span>
                  </ContainerInputResultItemTitle>

                  <ContainerInputResultItemCategory>
                    <span>{product?.category?.short_description}</span>
                  </ContainerInputResultItemCategory>

                  <ContainerInputResultItemPrice>
                    {RoundHelper.toFormatted(product?.price)}
                  </ContainerInputResultItemPrice>

                  <ContainerInputResultItemActions
                    onClick={() =>{
                      const isKg = product.un === 'Kg';
                      const qtd = isKg ? (product.quantity_increment || 0.1).toFixed(3).replace('.', ',')
                        : (product?.quantity_increment || 1).toString();
                      handleCheckoutActions(
                        checkoutActionTypes.ADD_PLU_CHECKOUT,
                        product.product_id ? product.product_id : '',
                        qtd
                      )
                    }}
                  >
                    <span>
                      <MdAddShoppingCart size={18} />
                      Comprar
                    </span>
                  </ContainerInputResultItemActions>
                </ContainerInputResultItem>
              );
            }}
          />
        </ContainerInputBox>
        <NavLink />
      </Container>
      {/* <ContainerMobile>
        <MenuItem key={1}>
          <NavLink to="/">
            <FiHome size={32} color="#ff9d00" />
            <span>Início</span>
          </NavLink>
        </MenuItem>
        <MenuItem key={2}>
          <NavLink to="/checkout">
            <FaShoppingCart size={32} color="#ff9d00" />
            <span>Pedidos</span>
          </NavLink>
        </MenuItem>
        <MenuItem key={3}>
          <NavLink to="/account">
            <FiUser size={32} color="#ff9d00" />
            <span>Conta</span>
          </NavLink>
        </MenuItem>
      </ContainerMobile> */}
    </Root>
  );
};

export default Search;
